module.exports = __webpack_public_path__ + "static/media/angieveguilla-22.65dfad3d.jpg";